export default "__VITE_ASSET__CsTjyCR6__"